import React from 'react'

import Tutorial from '../../generic/CourseSummary'
import MoreButton from '../../generic/MoreButton'
import CourseListPlaceholder from '../CourseListPlaceholder'

function LatestCourses({ latestTutorials }) {
  return latestTutorials && latestTutorials.length > 0 ? (
    <section className="tutorials wrapper">
      <h2 className="tutorials__title">Latest Courses</h2>
      <div className="list">
        {latestTutorials.map((tutorial) => (
          <Tutorial
            key={`latest-tutorial-${tutorial.id}`}
            slug={tutorial.slug}
            summary={tutorial.description}
            teacher={tutorial.artist.title}
            teacherSlug={tutorial.artist.slug}
            title={tutorial.title}
            thumb={tutorial.photo.boxThumb}
            new={tutorial.new}
          />
        ))}
      </div>
      <MoreButton url="/tutorials" />
    </section>
  ) : (
    <CourseListPlaceholder title="Latest Courses" />
  )
}

export default LatestCourses
